import { Component, Input, EventEmitter, Output } from '@angular/core';
import { IconType } from 'shared/ui';

export interface TabItem {
  icon: string;
  iconType?: IconType;
  name: string;
}

@Component({
  selector: 'viewer-tab',
  templateUrl: './tab.component.html',
  styleUrl: './tab.component.scss',
})
export class TabComponent {
  @Input() tabItems: TabItem[] = [];

  @Input() selectedTab!: string;
  @Output() selectedTabChange = new EventEmitter<string>();

  private isWebView(): boolean {
    return /BukHybridApp\//.test(navigator.userAgent);
  }

  // 필터링된 탭 아이템들을 반환하는 getter
  get filteredTabItems(): TabItem[] {
    // 웹뷰가 아닌 경우(순수 웹), '필기' 탭을 제외
    if (!this.isWebView()) {
      return this.tabItems.filter((item) => item.name !== '필기');
    }
    // 웹뷰인 경우 모든 탭 표시
    return this.tabItems;
  }

  _onTabClick(name: string): void {
    this.selectedTab = name;
    this.selectedTabChange.emit(this.selectedTab);
  }
}
